'use client'

import {useCallback, useEffect, useRef} from 'react'
import type {PluginConfigProps} from '@/plugins/sdk'
import {getAuthToken} from '@/lib/api'

type Props = PluginConfigProps & {
    pluginId: string
}

export function IframePluginView({account, pluginId}: Props) {
    const iframeRef = useRef<HTMLIFrameElement | null>(null)
    const wxid = account?.wxid || ''
    const src = wxid
        ? `/plugin-ui/${encodeURIComponent(pluginId)}/index.html?wxid=${encodeURIComponent(wxid)}`
        : `/plugin-ui/${encodeURIComponent(pluginId)}/index.html`

    const postInit = useCallback(() => {
        iframeRef.current?.contentWindow?.postMessage({
            type: 'wxbot-plugin:init',
            pluginId,
            wxid,
            token: getAuthToken() || '',
            apiBaseUrl: `/api/plugins/${encodeURIComponent(pluginId)}`,
        }, '*')
    }, [pluginId, wxid])

    useEffect(() => {
        function onMessage(event: MessageEvent) {
            if (event.source !== iframeRef.current?.contentWindow) return
            if (event.data?.type === 'wxbot-plugin:ready' && event.data?.pluginId === pluginId) {
                postInit()
            }
        }
        window.addEventListener('message', onMessage)
        return () => window.removeEventListener('message', onMessage)
    }, [pluginId, postInit])

    return (
        <iframe
            ref={iframeRef}
            title={`${pluginId} 插件配置`}
            src={src}
            className="h-[calc(100dvh-77px)] min-h-0 w-full border-0 bg-transparent"
            sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
            onLoad={postInit}
        />
    )
}
